"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designSystem = require("@slyk/design-system");

var _react = _interopRequireWildcard(require("react"));

var _qs = _interopRequireDefault(require("qs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Google authentication url.
 */
var googleAuthenticationUrl = "https://accounts.google.com/o/oauth2/v2/auth";
/**
 * `Props` type.
 */

/**
 * `StyledLink` styled component.
 */
var StyledLink = (0, _styledComponents["default"])(_designSystem.Link).withConfig({
  displayName: "google-link__StyledLink",
  componentId: "sc-nztffe-0"
})(["", ""], _designSystem.typography.styles.textSmall);
/**
 * `GoogleLink` component.
 */

function GoogleLink(props) {
  var children = props.children,
      className = props.className,
      credentials = props.credentials,
      disabled = props.disabled,
      onClick = props.onClick;
  var googleUrl = (0, _react.useMemo)(function () {
    var _credentials$state;

    var params = {
      client_id: credentials.clientId,
      nonce: credentials.clientId,
      redirect_uri: credentials.redirectUrl,
      response_type: 'id_token token',
      scope: 'https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly',
      state: _qs["default"].stringify(_objectSpread({
        backRoute: credentials.backRoute,
        identityProvider: 'google',
        scope: 'contacts',
        slug: credentials.slug,
        type: credentials.type
      }, (_credentials$state = credentials.state) !== null && _credentials$state !== void 0 ? _credentials$state : {}))
    };
    var url = new URL(googleAuthenticationUrl);
    url.search = _qs["default"].stringify(params);
    return url.href;
  }, [credentials]);
  return /*#__PURE__*/_react["default"].createElement(StyledLink, {
    className: className,
    disabled: disabled,
    href: disabled ? undefined : googleUrl,
    onClick: onClick
  }, children);
}
/**
 * Export `GoogleLink` component.
 */


var _default = GoogleLink;
exports["default"] = _default;